<!--
  TeacherContractHint: warning when a teacher without employee contract is assigned (course dialogs, course plan, substitutions).
  Only a hint, saving stays possible. Status batched + cached (teacherContracts.helper, contract-manager employee-contracts/status);
  unknown status (no right, older backend) shows nothing. The profile link opens in a new tab (the dialog keeps its entries).
  Props: teacher (id / employee object / undefined), dense (one line, e.g. in lists)
-->
<template>
  <div v-if="missing" :class="{'tch--dense': dense}" class="tch tone-warn" role="status">
    <v-icon class="tch__icon" color="warning" small>mdi-file-document-alert-outline</v-icon>
    <span class="tch__text">{{ text }}</span>
    <a v-if="profileHref" :href="profileHref" class="tch__link" rel="noopener" target="_blank" @click.stop>
      Vertrag anlegen<v-icon color="inherit" x-small>mdi-open-in-new</v-icon>
    </a>
  </div>
</template>

<script lang="ts">
import Vue from 'vue';
import {lacksContract, MISSING_CONTRACT_HINT} from '@/helpers/contracts/teacherContracts.helper';

export default Vue.extend({
  props: {
    /** Teacher id or employee object */
    teacher: {type: [String, Object], default: undefined},
    dense: {type: Boolean, default: false},
  },
  data: () => ({
    missing: false,
    request: 0,
    text: MISSING_CONTRACT_HINT,
  }),
  computed: {
    teacherId(): string {
      const teacher = this.teacher as unknown;
      if (!teacher) {
        return '';
      }
      // employee object (populated) or id (string / ObjectId)
      const isId = typeof teacher !== 'object' || typeof (teacher as { toHexString?: unknown }).toHexString === 'function';
      const id = isId ? teacher : (teacher as { _id?: unknown })._id;
      return id ? String(id) : '';
    },
    profileHref(): string {
      return this.teacherId ? this.$router.resolve({name: 'Lehrkraft', params: {employeeId: this.teacherId}}).href : '';
    },
  },
  watch: {
    teacherId: {
      immediate: true,
      async handler(id: string) {
        const request = ++this.request;
        this.missing = false;
        if (!id) {
          return;
        }
        const missing = await lacksContract(id);
        if (request === this.request) {
          this.missing = missing;
        }
      },
    },
  },
});
</script>

<style scoped>
.tch {
  display: flex;
  flex-wrap: wrap;
  align-items: center;
  gap: 4px 8px;
  padding: 8px 10px;
  border-radius: 8px;
  font-size: 13px;
  line-height: 1.35;
}

.tch--dense {
  padding: 4px 8px;
  font-size: 12px;
}

.tch__text {
  flex: 1 1 220px;
  min-width: 0;
}

.tch__link {
  display: inline-flex;
  align-items: center;
  gap: 2px;
  color: inherit;
  font-weight: 500;
  text-decoration: underline;
  white-space: nowrap;
}
</style>
<style src="@/components/common/modern/modern.css"></style>
